import React from "react";
import "./headerStyle.css";
import BGlogo from '../../img/DkLogo-BackGround.png';


const Header = () => {
  return (
    <header
      className="header"
      style={{ backgroundImage: `url(${BGlogo})` }}
    >
      <div className="header-content">
        <h1>No ambiente certo a sua empresa cresce.<br></br>
            Reserve agora seu espaço:</h1>

        <div className="header-buttons">
          <a href="#planos" className="btn-reserve">Reserve aqui</a>
          <a href="#sobre" className="btn-about">Sobre nós</a>
        </div>
      </div>
    </header>
  );
};

export default Header;
